<template>
    <div class="photochooser__tab-content">
        <div class="row collage-photo" v-if="hasCartPhotos">
            <CollagePhotoItemPhotoChooser v-for="(photo, photoId) in cartPhotos"
                                          :key="photoId"
                                          :photo="photo"
                                          :selected="$parent.isSelected(photoId)"
                                          :initially-selected="$parent.isInitiallySelected(photoId)"
                                          :enable-zoom="false"
                                          @photo-selected="$parent.selectPhoto(photo)"
                                          @photo-unselected="$parent.unselectPhoto(photoId)"/>
        </div>
        <div class="row py-10 text-center" v-else>
            <div class="col-12">
                <div class="h2">{{ $t('photo_chooser.no_photos_in_cart') }}</div>
            </div>
        </div>
    </div>
</template>


<script>
    import CollagePhotoItemPhotoChooser from '@/components/CollagePhotoItemPhotoChooser.vue'
    // import CollagePhotoItem from '@/components/CollagePhotoItem.vue'

    export default {
        components: {
            CollagePhotoItemPhotoChooser,
            // CollagePhotoItem,
        },

        data() {
            return {
                cartPhotos: {},
            }
        },

        computed: {
            hasCartPhotos() {
                return Object.keys(this.cartPhotos).length > 0
            }
        },

        mounted() {
            this.setCartPhotos()
        },

        methods: {
            setCartPhotos() {
                let digitalItems = this.$store.getters['cart/getDigitalItems']
                for (let item of digitalItems) {
                    console.log('item', item)
                    for (let photo of item.photos) {
                        // qui photo.id viene castato implicitamente da intero a stringa
                        this.$set(this.cartPhotos, photo.id, photo)
                    }
                }
            },
        }
    }
</script>
